export default __webpack_public_path__ + "static/media/82t.a29df56a.jpg";